import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { GrUpload, GrDownload } from "react-icons/gr";
import { useRef } from "react";

export default function UploadBatchModal({ openModal, onClose }) {
  const handleCloseModal = () => {
    onClose();
  };

  const handleDownload = () => {
    const sampleFile = new Blob(["Sample File Content"], {
      type: "text/plain",
    });
    const fileUrl = URL.createObjectURL(sampleFile);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "sample-file.txt";
    link.click();
    URL.revokeObjectURL(fileUrl);
  };

  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    // Do something with the selected file, such as uploading it to a server
    console.log("Selected file:", selectedFile);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  //   const handleDownload = (fileUrl) => {
  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.download = "";
  //     link.click();
  //   onClick={() => handleDownload('/path/to/your/file')} // Replace with the actual file URL or path
  //   };

  const handleSubmitModal = () => {
    console.log("modal is submitted");
    onClose();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation();
    }
  };
  return (
    <>
      <Dialog
        open={openModal}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        onClick={handleBackdropClick}
      >
        <DialogTitle
          sx={{ fontWeight: 700, fontSize: "20px", fontFamily: "Poppins" }}
        >
          Upload Batch
          <IconButton
            aria-label="close"
            onClick={() => handleCloseModal()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#000000",
            }}
          >
            <RxCross2 />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Paper
            style={{
              //   width: "708px",
              height: "311px",
              borderRadius: "16px",
              backgroundColor: "rgba(244, 244, 244, 1)",
              padding: "65px",
            }}
          >
            <div className="d-flex flex-column align-items-center">
              <input
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}
                ref={fileInputRef}
              />
              <GrUpload
                style={{
                  height: "32px",
                  width: "32px",
                  cursor: "pointer",
                  color: "rgba(1, 1, 2, 0.6)",
                }}
                onClick={handleButtonClick}
              />
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "18px",
                  fontFamily: "Poppins",
                  paddingTop: "10px",
                  color: "rgba(1, 1, 2, 0.6)",
                }}
              >
                Upload/ Drag and drop the file
              </Typography>
              <Button
                onClick={handleButtonClick}
                style={{
                  fontWeight: 600,
                  backgroundColor: "rgba(1, 1, 2, 1)",
                  color: "white",
                  borderRadius: "8px",
                  textTransform: "none",
                  width: "236px",
                  fontSize: "18px",
                  width: "210px",
                  height: "48px",
                  fontFamily: "Poppins",
                  marginTop: "20px"
                }}
              >
                Upload File
              </Button>
            </div>
          </Paper>
          <div className="row align-items-center pt-2 pl-2">
            <GrDownload
              onClick={() => handleDownload()}
              style={{
                height: "11px",
                width: "11px",
                marginRight: "4px",
                cursor: "pointer",
              }}
            />
            <Typography style={{ fontSize: "14px", fontWeight: 600, fontFamily: "Poppins" }}>
              Download Sample File
            </Typography>
          </div>
        </DialogContent>
        <DialogActions style={{ paddingBottom: "15px" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{
              color: "rgba(36, 183, 170, 1)",
              marginRight: "10px",
              textTransform: "none",
              fontSize: "20px",
              width: "210px",
              height: "48px",
              fontWeight: 600,
              borderRadius: "8px",
              border: "2px solid",
              fontFamily: "Poppins",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSubmitModal()}
            variant="contained"
            style={{
              fontWeight: 600,
              backgroundColor: "#24B7AA",
              borderRadius: "8px",
              textTransform: "none",
              marginRight: "10px",
              width: "236px",
              fontSize: "18px",
              width: "210px",
              height: "48px",
              fontFamily: "Poppins",
            }}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
